/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import * as RouterSelectors from './router';
export const currentIdSelector = createSelector(RouterSelectors.activeQuerySelector, ({ id }) => id);
